export default __webpack_public_path__ + "static/media/sadhguru_desktop.23d41522.webp";